
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 270 270"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 270 270","style":"enable-background:new 0 0 270 270;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9\n\t\t\ts-12.9-5.8-12.9-12.9V151.2z"}})]),_c('g',[_c('path',{staticClass:"st1",attrs:{"d":"M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9\n\t\t\ts5.8-12.9,12.9-12.9H118.8z"}})]),_c('g',[_c('path',{staticClass:"st2",attrs:{"d":"M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z"}}),_c('path',{staticClass:"st2",attrs:{"d":"M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9\n\t\t\tc7.1,0,12.9,5.8,12.9,12.9V118.8z"}})]),_c('g',[_c('path',{staticClass:"st3",attrs:{"d":"M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z"}}),_c('path',{staticClass:"st3",attrs:{"d":"M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9\n\t\t\tc0,7.1-5.8,12.9-12.9,12.9H151.2z"}})])])])
          )
        }
      }
    